/** Detect installed PWA / standalone display mode (no Vuex or Firebase deps). */

const STANDALONE_DISPLAY_MODES = ['standalone', 'fullscreen', 'minimal-ui'];

export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;

  for (const mode of STANDALONE_DISPLAY_MODES) {
    if (window.matchMedia?.(`(display-mode: ${mode})`)?.matches) return true;
  }

  // iOS Safari / iPadOS home-screen web app
  if (window.navigator.standalone === true) return true;

  return false;
}
